import apiClient from "../utils/api";

class AuthService {
  async login(userData) {
    return apiClient("/auth/login", {
      method: "POST",
      body: userData,
    });
  }
}

const auth_service = new AuthService ()

export default auth_service

